import { Estimate, EstimateType } from "../client-api.service";
import { PeriodEstimatesBase } from "./models/period-estimates";

const ESTIMATE_TYPE_PERIOD_EST_KEY_PAIRS = [
  [ EstimateType.EstNewLeases, 'estNewLeases' ],
  [ EstimateType.EstNewRate, 'estNewRate' ],
  [ EstimateType.EstRenewalLeases, 'estRenewalLeases' ],
  [ EstimateType.EstRenewalRate, 'estRenewalRate' ],
  [ EstimateType.OriginalAvgRate, 'origAvgRate' ],
  [ EstimateType.OriginalFpRate, 'origFpRate' ],
  [ EstimateType.OriginalLeaseCount, 'origLeaseCount' ],
  [ EstimateType.TargetOccupancyPct, 'tgtOccPct' ],
  [ EstimateType.TargetRateIncreasePct, 'tgtRateIncreasePct' ],
  [ EstimateType.TargetRenewalPct, 'tgtRenewalPct' ],
  [ EstimateType.UnitCount, 'unitCount' ],
  [ EstimateType.EstBaseFpRate, 'estBaseFpRate' ]
] as const;

type PeriodEstimateValueKey = typeof ESTIMATE_TYPE_PERIOD_EST_KEY_PAIRS[number][1];

const ESTIMATE_TYPE_TO_PERIOD_KEY_MAP = new Map<EstimateType, PeriodEstimateValueKey>(ESTIMATE_TYPE_PERIOD_EST_KEY_PAIRS);

/** Sets the estimate value on a period estimate based on the source estimates's type */
export function setPeriodEstimateValue(srcEst: Estimate, destEst: PeriodEstimatesBase): void {
  const key = getEstimateTypeKey(srcEst.estimateType);
  destEst[key] = srcEst.value;
  if (srcEst.estimateType === EstimateType.EstRenewalRate) {
    if (srcEst.value == null) {
      destEst.estRenewalRateEstimateId = undefined;
    } else if (srcEst.estimateId > 0) {
      destEst.estRenewalRateEstimateId = srcEst.estimateId;
    }
    destEst.estRenewalRateSentToEntrataOn = srcEst.sentToEntrataOn;
  }
}

/** Gets the EstimateType value from a PeriodEstimatesBase */
export function getEstimateValueByEstimateType(estimateType: EstimateType, periodEstimate: PeriodEstimatesBase | null | undefined): number | undefined {
  return periodEstimate ? periodEstimate[getEstimateTypeKey(estimateType)] : undefined;
}

function getEstimateTypeKey(estimateType: EstimateType) {
  const key = ESTIMATE_TYPE_TO_PERIOD_KEY_MAP.get(estimateType);
  if (key == null) {
    console.log('Key not found.');
    throw Error('Estimate type does not have matching key.');
  }
  return key;
}
